import unauthorizedImage from '../../assets/images/unauthorized';
import { NudosButton } from '../../components/NudosComponents';
import { useUserAuth } from '../../state/userAuthContext';
import { displayErrorNotification } from '../../utils/displayNudosStandardNotifications';
import './UnauthorizedView.scss';

const UnauthorizedView = () => {
  const { logOut } = useUserAuth();
  const image = unauthorizedImage;

  const goBackToOrigin = () => {
    try {
      logOut?.();
      window.location.href = '/auth/login';
    } catch (error) {
      displayErrorNotification();
    }
  };

  return (
    <div className="unauthorizedView">
      <div className="viewContents">
        <div className="imageContainer">
          <img src={image} alt="Sin autorización" />
        </div>
        <div className="title">Lo sentimos, no tienes acceso a esta página</div>
        <div className="subtitle">Si crees que se trata de un error, contacta a nuestro equipo de soporte</div>
        <NudosButton componentSize="small" buttonText="Volver al inicio" handleClick={goBackToOrigin} />
      </div>
    </div>
  );
};

export default UnauthorizedView;
